import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Link, NavLink, Outlet } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { navLinkHeaderStylefunc, navfunc } from "../../../routes/navLinkStylefunc";
import { assignReferralBasePath, manageReferralBasePath } from "../../../routes/routePaths";
import { getAccessTypes } from "../../../hooksAndFunctions/functions/getAccessTypes";
import { useGetSiteCoreCMSData } from "../../../reactQueries/commonRQHooks";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ReferralHeader = () => {
  const {
    clientPortalAdminType
  } = getAccessTypes()

  const {
    hasA2Access,
    hasA3Access
  } = clientPortalAdminType

  const {isSuccess: isSuccessOnSiteCoreCMS, error: errorOnSiteCoreCMS, data: referralsCMSDataFromAPI, isError: isErrorOnSiteCoreCMS, 
    isFetching: isFetchingOnSiteCoreCMS} = useGetSiteCoreCMSData({pagename: "Referrals"});

  const [referralsCMSData, setReferralsCMSData] = useState({
    title: "",
    description: "",
    tabNavigationTitle: "",
    pageContent: {},
  });

  const fetchReferralsCMSData = () =>{
    if(referralsCMSDataFromAPI && referralsCMSDataFromAPI.Pages){
      referralsCMSDataFromAPI.Pages.map((el) => {
       if (el.Key === "Referrals") {
          const { Title, Description, TabNavigationTitle, Components } = el;
          setReferralsCMSData({ title: Title, description: Description, tabNavigationTitle: TabNavigationTitle, pageContent: Components });
       }
      });
    }
  }

  useEffect(() => {
    fetchReferralsCMSData();
   }, [referralsCMSDataFromAPI]);

  return (
    <React.Fragment>

      <Box sx={{ width: "100%" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          justifyContent="center"
          alignItems="center"
          divider={<Divider orientation="vertical" flexItem />}
        >

          <Button
            variant="text"
            size="large"
            component={NavLink}
            style={navLinkHeaderStylefunc}
            to={assignReferralBasePath}
            disabled={
              !!hasA2Access || hasA3Access
            }
          >
            {/* Assign Referral Requests */}
            {referralsCMSData?.pageContent["AssignReferralRequestsList"]?.Title}
          </Button>
          <Button
            variant="text"
            size="large"
            component={NavLink}
            style={navLinkHeaderStylefunc}
            to={manageReferralBasePath}
          >
            {/* Manage Referral Requests */}
            {referralsCMSData?.pageContent["ManageReferralRequestList"]?.Title}
          </Button>
        </Stack>
        <Divider sx={{ margin: "10px" }} />
      </Box>
      {/** aquires all child route element components */}
      <Outlet context={referralsCMSData}/>
      {/* <Outlet
        context={{
          dataFromCmsApi: referralsCMSDataFromAPI,
          refCmsData: [referralsCMSData, setReferralsCMSData],
        }}
      /> */}
    </React.Fragment>
  );
};

export default ReferralHeader;
